import clsx from 'clsx'
import React from 'react'

import {default as HeaderButton} from '../header-button/HeaderButton'
import {LinkListProps} from './LinkList.types'
import {listClasses} from './LinkList@mobile.classes'

export function LinkList({list, className, onClick, separation = true}: LinkListProps) {
  return (
    <ul className={clsx(listClasses.root, className)}>
      {list.map((item, index) => {
        return (
          <li key={index} {...(onClick? {onMouseEnter: () => onClick(item?.id)} : {})}>
            <HeaderButton className={listClasses.listItem} href={item.href} variant='pseudo' active transparent {...item.buttonProps} onPress={() => onClick?.(item.id)}>
              {item.label}
            </HeaderButton>
            {list.length - 1 !== index && separation && <div className={listClasses.separator} />}
          </li>
        )
      })}
    </ul>
  )
}
